import { useLocale } from '../hooks/useLocale'
import styles from './Hero.module.css'

export default function Hero() {
  const { t } = useLocale()

  return (
    <section className={styles.hero} id="hero" aria-labelledby="hero-headline">
      <div className={styles.container}>
        <h1 className={styles.headline} id="hero-headline">{t('hero.headline')}</h1>
        <p className={styles.valueProp}>{t('hero.valueProp')}</p>
        <a href="#contact" className={styles.cta} aria-label={t('hero.cta')}>
          {t('hero.cta')}
        </a>
      </div>
    </section>
  )
}
